import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState } from 'react';
import uniqueId from 'lodash.uniqueid';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import BonusRewardCard from './BonusRewardCard';
import { connect } from 'react-redux';
import { rewardsDuck } from '../../ducks/rewards';
import BonusGameTileComponent from '../bonusGameTile/bonusGameTile';
import { LoyaltyAccountStatus } from '../../util/LoyaltyAccountStatus';
import { getLoyaltyStorage } from '../../util';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import { de } from 'date-fns/locale';
var rewardsOperations = rewardsDuck.operations;

var BonusRewardListing = function BonusRewardListing(props) {
  var _BonusGameTile$;

  var _props$model = props.model,
      _props$model$Header = _props$model.Header,
      Header = _props$model$Header === void 0 ? {} : _props$model$Header,
      _props$model$Headline = _props$model.Headline,
      Headline = _props$model$Headline === void 0 ? {} : _props$model$Headline,
      _props$model$NoBonusR = _props$model.NoBonusRewardsHeadline,
      NoBonusRewardsHeadline = _props$model$NoBonusR === void 0 ? {} : _props$model$NoBonusR,
      _props$model$BonusGam = _props$model.BonusGameTile,
      BonusGameTile = _props$model$BonusGam === void 0 ? {} : _props$model$BonusGam,
      _props$model$CtaLinks = _props$model.CtaLinks,
      CtaLinks = _props$model$CtaLinks === void 0 ? {} : _props$model$CtaLinks,
      _props$model$RewardBa = _props$model.RewardBadge,
      RewardBadge = _props$model$RewardBa === void 0 ? null : _props$model$RewardBa;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      bonusRewards = _useState2[0],
      setBonusRewards = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      pausedAccount = _useState4[0],
      setPausedAccount = _useState4[1];

  var bonusGameTileModel = (_BonusGameTile$ = BonusGameTile[0]) === null || _BonusGameTile$ === void 0 ? void 0 : _BonusGameTile$.fields;
  var id = uniqueId();
  var loyaltyStorage = getLoyaltyStorage();
  var flags = useFlags();
  var ldClient = useLDClient();
  var releaseRedemptionEngineV2 = flags['releaseRedemptionEngineV2PromosDstr6078'] ? flags['releaseRedemptionEngineV2PromosDstr6078'] : false;
  var useNewRebrandStyles = flags['releaseRebrandDstr6457'] || false;
  useEffect(function () {
    var asyncEffect = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _loyaltyStorage$accou;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!((loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou = loyaltyStorage.account) === null || _loyaltyStorage$accou === void 0 ? void 0 : _loyaltyStorage$accou.Status) === LoyaltyAccountStatus.Paused)) {
                  _context.next = 3;
                  break;
                }

                setPausedAccount(true);
                return _context.abrupt("return");

              case 3:
                if (!ldClient) {
                  _context.next = 8;
                  break;
                }

                _context.next = 6;
                return ldClient.waitForInitialization();

              case 6:
                _context.next = 9;
                break;

              case 8:
                return _context.abrupt("return");

              case 9:
                props.getBonusRewards(releaseRedemptionEngineV2).then(function (response) {
                  setBonusRewards(response);
                }).catch(function (e) {
                  console.error('error', e.message);
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function asyncEffect() {
        return _ref.apply(this, arguments);
      };
    }();

    asyncEffect();
  }, [releaseRedemptionEngineV2, ldClient]);

  if (pausedAccount) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-reward-listing-container'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'container'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'row'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'col-lg-12'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-reward-listing'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-reward-listing__header-container'
  }, /*#__PURE__*/React.createElement(Text, {
    tag: 'span',
    field: Header,
    className: 'cb-bonus-reward-listing__header'
  }), /*#__PURE__*/React.createElement(Text, {
    tag: 'span',
    field: (bonusRewards === null || bonusRewards === void 0 ? void 0 : bonusRewards.length) ? Headline : NoBonusRewardsHeadline,
    className: 'cb-bonus-reward-listing__headline'
  })), /*#__PURE__*/React.createElement("div", {
    className: 'cb-bonus-reward-listing__bonus-container'
  }, bonusRewards === null || bonusRewards === void 0 ? void 0 : bonusRewards.map(function (bonusReward, index) {
    var _props$cart;

    return /*#__PURE__*/React.createElement(BonusRewardCard, {
      key: "bonus-reward-".concat(id, "-").concat(index),
      model: bonusReward.fields,
      ctaLinks: CtaLinks,
      rewardBadge: RewardBadge,
      releaseRedemptionEngineV2: releaseRedemptionEngineV2,
      hasCart: ((_props$cart = props.cart) === null || _props$cart === void 0 ? void 0 : _props$cart.length) > 0
    });
  })))))), useNewRebrandStyles ? /*#__PURE__*/React.createElement("div", {
    className: 'container'
  }, /*#__PURE__*/React.createElement(BonusGameTileComponent, {
    model: bonusGameTileModel
  })) : /*#__PURE__*/React.createElement(BonusGameTileComponent, {
    model: bonusGameTileModel
  }));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    cart: state.cart.cart
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getBonusRewards: function getBonusRewards(releaseRedemptionEngineV2) {
      return dispatch(rewardsOperations.handleGetBonusRewards(releaseRedemptionEngineV2));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BonusRewardListing);